import { Component, OnInit, OnDestroy } from '@angular/core';
import {SharedDataService} from '../../shared-data.service';
import {enumValue} from '../../constant.enum';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-sfd-please-call',
    templateUrl: './sfd-please-call.component.html',
    styleUrls: ['./sfd-please-call.component.scss'],
    standalone: false
})
/**
 * classs representing a SfdPleaseCallComponent
 */
export class SfdPleaseCallComponent implements OnInit, OnDestroy {
  enumValue = enumValue;
  public employeeNo: any;
  public employerNo: any;
  public tokenExpired: boolean;
  public rateLimitMessage: string;
  private rateLimitLockDurationSub: Subscription;

  /**
   * Create a SfdPleaseCallComponent
   * @param sharedDataService
   */
  constructor( private sharedDataService: SharedDataService) { }

  /**
   * onInit to check expired token
   */
  ngOnInit() {
    this.employeeNo = this.sharedDataService.validatePhone(enumValue.EMPLOYEE_PhoneNo_KEY);
    this.employerNo = this.sharedDataService.validatePhone(enumValue.EMPLOYER_PhoneNo_KEY);
    this.sharedDataService.getExpiredTokenStatus().subscribe(data => {
      this.tokenExpired =  data;
    });
    // Clear rate limit lock duration after reading to prevent it from persisting on future visits
    this.rateLimitLockDurationSub = this.sharedDataService.getRateLimitLockDuration().subscribe(data => {
      if (data) {
        const hours = parseInt(data, 10);
        if (!isNaN(hours) && hours > 0) {
          const hourLabel = hours === 1 ? '1 hour' : hours + ' hours';
          this.rateLimitMessage = enumValue.RATE_LIMIT_LOCK_MESSAGE.replace('{duration}', hourLabel);
        }
        this.sharedDataService.setRateLimitLockDuration(null);
      }
    });
  }

  ngOnDestroy() {
    if (this.rateLimitLockDurationSub) {
      this.rateLimitLockDurationSub.unsubscribe();
    }
  }
}
